import React from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import ABSelect from "../Common/ABSelect";
import Footer from "../Footer.js";

const QuestionForm = ({
  questionName,
  question,
  questionOptions,
  handleQuestionChange,
  handleSave,
  answerError,
  handleBackNavigation,
  questionValue,
  answered,
  previousAnswer,
}) => {
  const saveHandler = (e) => {
    e.preventDefault();
    handleSave(questionName);
  };

  const handleBack = (e) => {
    e.preventDefault();
    handleBackNavigation();
  };
  console.log("value of question...", questionValue)
  return (
    <>
      <div className="tab-content-mt-0" id="myTabContent">
        <p>{question}</p>
      </div>
      <div className="tab-content" id="myTabContent">
        {!answered&&<div className="row">
          <ABSelect
            type={1}
            name={questionName}
            id={questionName}
            errId={`err_${questionName}`}
            placeholder={"Select"}
            options={questionOptions}
            selectOption={(e) => handleQuestionChange(e)}
            value={questionValue}
            isRequired={1}
          />
        </div>}
        {answered&&<div className="row" style={{pointerEvents:"none", opacity:0.7 }}>
          <ABSelect
            type={1}
            name={questionName}
            id={questionName}
            errId={`err_${questionName}`}
            placeholder={"Select"}
            options={questionOptions}
            selectOption={(e) => handleQuestionChange(e)}
            value={questionValue}
            isRequired={1}
          />
        </div>}
        {answerError === true && (
          <p className="err text-danger">This field is required.</p>
        )}
        <div className="row">
          <div className="col-auto d-flex justify-content-between">
            {/* <button
              className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
              onClick={(e) => handleBack(e)}
            >
              Back
            </button> */}
            {previousAnswer && previousAnswer === questionValue ? <></>  
            : !answered && (<button
              className="btn btn-primary btn-lg btn-block mt-3"
              onClick={(e) => saveHandler(e)}
            >
              Save
            </button>)}
          </div>
        </div>
      </div>
    </>
  );
};
export default QuestionForm;
